import { isEntityUri } from '#app/lib/boolean_tests'
import type { ActivityId, ActorName } from '#server/types/activity'
import type { SerializedUser } from '#users/lib/users'

const { host } = location

function getActorFediverseAcct (actorName: ActorName) {
  return `${actorName}@${host}`
}

export function getUserFediverseAcct (user: SerializedUser) {
  const { username, stableUsername } = user
  return getActorFediverseAcct(stableUsername || username)
}

export function getActorPageUrl (name: ActorName) {
  if (name.startsWith('shelf-')) {
    const shelfId = name.split('-')[1]
    return `/shelves/${shelfId}`
  } else if (isEntityUri(name.replace('-', ':'))) {
    const uri = name.replace('-', ':')
    return `/entity/${uri}`
  } else {
    return `/users/${name}`
  }
}

export function getObjectPageUrl (activityId: ActivityId) {
  const id = new URL(activityId).searchParams.get('id')
  if (id.startsWith('item-')) {
    const itemId = id.split('-')[1]
    return `/items/${itemId}`
  } else {
    const uri = id.split('-').slice(0, 2).join(':')
    return `/entity/${uri}`
  }
}
